var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('time',{attrs:{"datetime":("PT" + _vm.value + "S")}},[_vm._v(_vm._s(_vm._f("readingTime")(_vm.value,_vm.language)))])}
var staticRenderFns = []

export { render, staticRenderFns }